import { defineMessages } from "react-intl";

const messages = defineMessages({
  addConfirmationCancel: {
    id: "map.toolbar.popovers.territories.addConfirmation.cancel",
    defaultMessage: "Wait",
    description: "Add territory button confirmation - Wait",
  },
  addConfirmationGroup: {
    id: "map.toolbar.popovers.territories.addConfirmation.group",
    defaultMessage: "Please note, you will exit Group View by creating a new territory.",
    description: "Add territory button confirmation - new group",
  },
  addConfirmationOk: {
    id: "map.toolbar.popovers.territories.addConfirmation.ok",
    defaultMessage: "Got it",
    description: "Add territory button confirmation - Got It",
  },
  addConfirmationTerritory: {
    id: "map.toolbar.popovers.territories.addConfirmation.territory",
    defaultMessage:
      "Please note, you will exit the currently selected Territory by creating a new one.",
    description: "Add territory button confirmation - new territory",
  },
  addTerritory: {
    id: "map.toolbar.popovers.territories.addTerritory",
    defaultMessage: "Add New Territory",
    description: "Add territory button in territories popover on the Map page",
  },
  anyCreator: {
    id: "map.toolbar.popovers.territories.anyCreator",
    defaultMessage: "Any Creator",
    description: "Territories popover Creators placeholder",
  },
  anyMember: {
    id: "map.toolbar.popovers.territories.anyMember",
    defaultMessage: "Any Member",
    description: "Territories popover Shared With placeholder",
  },
  anyRegion: {
    id: "map.toolbar.popovers.territories.anyRegion",
    defaultMessage: "Any Region",
    description: "Territories popover Region placeholder",
  },
  clear: {
    id: "map.toolbar.popovers.territories.clear",
    defaultMessage: "Clear",
    description: "Territories popover filter clear",
  },
  creators: {
    id: "map.toolbar.popovers.territories.creators",
    defaultMessage: "Creator(s)",
    description: "Territories popover Creators title",
  },
  download: {
    id: "map.toolbar.popovers.territories.download",
    defaultMessage: "Download all territory bounds",
    description: "Download territories tooltip on the Map page",
  },
  noResultsClear: {
    id: "map.toolbar.popovers.territories.noResults.clear",
    defaultMessage: "Clear filters",
    description: "Clear filters button in an Alert to show when search produced no results",
  },
  noResultsDescription: {
    id: "map.toolbar.popovers.territories.noResults.description",
    defaultMessage: "Your search may have no results, or there may be too many filters applied.",
    description: "Description in an Alert to show when search produced no results",
  },
  noResultsTitle: {
    id: "map.toolbar.popovers.territories.noResults.title",
    defaultMessage: "No results",
    description: "Title of an Alert to show when search produced no results",
  },
  noTerritoriesAction: {
    id: "map.toolbar.popovers.territories.noTerritories.action",
    defaultMessage: "+ Add New Territory",
    description: "Action in an Alert to show when there are no territories",
  },
  noTerritoriesDescription: {
    id: "map.toolbar.popovers.territories.noTerritories.description",
    defaultMessage: "You don’t have any territories yet.",
    description: "Description of an Alert to show when there are no territories",
  },
  noTerritoriesTitle: {
    id: "map.toolbar.popovers.territories.noTerritories.title",
    defaultMessage: "No territories yet",
    description: "Title of an Alert to show when there are no territories",
  },
  okText: {
    id: "map.toolbar.popovers.territories.download.okText",
    defaultMessage: "Okay",
    description: "Territories popover download ok text",
  },
  placeholder: {
    id: "map.toolbar.popovers.territories.search.placeholder",
    defaultMessage: "Search Territories",
    description: "Search field in territories popover on the Map page",
  },
  popoverContent: {
    id: "map.toolbar.popovers.territories.popoverContent",
    defaultMessage:
      "Territories built with different area types, such as zip codes and counties, will be exported to separate CSV files. Territories built with Draw Mode will not be exported.",
    description: "Download territories popover content on the Map page",
  },
  region: {
    id: "map.toolbar.popovers.territories.region",
    defaultMessage: "Region",
    description: "Territories popover Region title",
  },
  sharedWith: {
    id: "map.toolbar.popovers.territories.sharedWith",
    defaultMessage: "Shared with",
    description: "Territories popover Shared With title",
  },
  title: {
    id: "map.toolbar.popovers.territories.title",
    defaultMessage: "{count} / {total} {total, plural, one {territory} other {territories}}",
    description: "Territories popover title",
  },
});

export default messages;
